import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, normalizeClass as _normalizeClass, withKeys as _withKeys } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "custom-hints-grid__loading"
}
const _hoisted_2 = {
  key: 1,
  class: "custom-hints-grid__empty"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "custom-hints-grid__cell custom-hints-grid__cell--note"
}
const _hoisted_5 = { class: "custom-hints-grid__note-name" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  class: "custom-hints-grid__cell custom-hints-grid__cell--empty"
}
const _hoisted_8 = { class: "custom-hints-grid__popup-inner" }
const _hoisted_9 = { class: "custom-hints-grid__popup-header" }
const _hoisted_10 = { class: "custom-hints-grid__popup-list" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "custom-hints-grid__popup-empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mosta_checkbox = _resolveComponent("mosta-checkbox")!

  return (_openBlock(), _createElementBlock("div", {
    class: "custom-hints-grid",
    style: _normalizeStyle({ height: _ctx.mHeight ? _ctx.mHeight + 'px' : '100%' })
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Загрузка..."))
      : (!_ctx.hintsData.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Нет подсказок"))
        : (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "custom-hints-grid__content",
            style: _normalizeStyle({ 'grid-template-columns': `repeat(${_ctx.titles.length}, 1fr)` })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.titles, (title) => {
              return (_openBlock(), _createElementBlock("div", {
                key: 'h-'+title.Id,
                class: "custom-hints-grid__header"
              }, _toDisplayString(title.Name), 1))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hintsData, (row, rowIdx) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: 'r-'+rowIdx
              }, [
                _createElementVNode("div", {
                  class: "custom-hints-grid__cell custom-hints-grid__cell--main",
                  onClick: ($event: any) => (_ctx.selectValWithHinted(row))
                }, _toDisplayString(row.HintedValue) + " (" + _toDisplayString(row.UsageCount) + ") ", 9, _hoisted_3),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.Notes, (note, noteIdx) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: 'n-'+rowIdx+'-'+noteIdx
                  }, [
                    note
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          (note.CanBeInsert)
                            ? (_openBlock(), _createBlock(_component_mosta_checkbox, {
                                key: 0,
                                "model-value": _ctx.noteHasSelection(note),
                                "onUpdate:modelValue": ($event: any) => (_ctx.toggleNoteCheckbox(row, note))
                              }, null, 8, ["model-value", "onUpdate:modelValue"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", _hoisted_5, _toDisplayString((note.SelectedHint || note.Hints[0])?.NameBack || '—'), 1),
                          (note.Hints.length > 1)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "custom-hints-grid__all-link",
                                ref_for: true,
                                ref: el => _ctx.setNoteAnchor(rowIdx, noteIdx, el),
                                onClick: _withModifiers(($event: any) => (_ctx.showNoteHints(rowIdx, noteIdx, note)), ["stop"])
                              }, " (Все) ", 8, _hoisted_6))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_7))
                  ], 64))
                }), 128))
              ], 64))
            }), 128))
          ], 4)),
    (_ctx.notePopupOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          ref: "notePopupEl",
          tabindex: "-1",
          class: "custom-hints-grid__popup",
          style: _normalizeStyle(_ctx.popupStyle),
          onMousedown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
          onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
          onKeydown: [
            _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"])),
            _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.closePopup && _ctx.closePopup(...args)), ["esc"]))
          ]
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.noteSearchText) = $event)),
                class: "custom-hints-grid__popup-search-input",
                placeholder: "Поиск...",
                onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.noteSearchText = ($event.target as HTMLInputElement).value))
              }, null, 544), [
                [_vModelText, _ctx.noteSearchText]
              ]),
              _createElementVNode("span", {
                class: "custom-hints-grid__popup-close",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closePopup && _ctx.closePopup(...args)))
              }, "×")
            ]),
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredNoteHints, (hint) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: hint.Id,
                  class: _normalizeClass(["custom-hints-grid__popup-item", { 'custom-hints-grid__popup-item--selected': hint.Selected }]),
                  onClick: ($event: any) => (_ctx.selectValHint(hint))
                }, [
                  _createVNode(_component_mosta_checkbox, {
                    "model-value": hint.Selected,
                    "onUpdate:modelValue": ($event: any) => (_ctx.selectValHint(hint))
                  }, null, 8, ["model-value", "onUpdate:modelValue"]),
                  _createElementVNode("span", null, _toDisplayString(hint.NameBack) + " (" + _toDisplayString(hint.Count) + ")", 1)
                ], 10, _hoisted_11))
              }), 128)),
              (!_ctx.filteredNoteHints.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, " Нет значений "))
                : _createCommentVNode("", true)
            ])
          ])
        ], 36))
      : _createCommentVNode("", true)
  ], 4))
}